import { Linkable } from '@/components/blocks/Linkable';
import { sidebarContentSX } from '@/components/blocks/SideBar/styles/paper';
import DynamicIcon from '@/components/icons/DynamicIcon';
import { Divider, IconButton, Paper, Stack, SxProps, Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

type Props = {
	title: string;
	href?: string;
	scrollable?: boolean;
	isMobile: boolean;
	elevation?: number;
	sidebarPaperSx?: SxProps;
	toggleOpen: () => void;
};

export const SidebarContent: FC<PropsWithChildren<Props>> = ({
	title,
	href,
	isMobile,
	toggleOpen,
	scrollable = false,
	sidebarPaperSx = {},
	elevation = 1,
	children,
}) => {
	return (
		<Paper
			sx={sidebarContentSX.paper({ sidebarPaperSx, isMobile, scrollable })}
			elevation={elevation}
		>
			{isMobile && (
				<>
					<Stack direction="row" spacing={0.5} sx={sidebarContentSX.stack}>
						<IconButton onClick={toggleOpen}>
							<DynamicIcon name="cancel" />
						</IconButton>
						{href ? (
							<Linkable
								id={`account-sidebar-${title.toLowerCase()}`}
								data-testid={`account-sidebar-${title.toLowerCase()}`}
								href={href}
							>
								<Typography
									variant="body1"
									fontSize={18}
									fontWeight={OpenSansFontWeights.light}
									sx={sidebarContentSX.title}
								>
									{title}
								</Typography>
							</Linkable>
						) : (
							<Typography
								variant="body1"
								fontSize={18}
								fontWeight={OpenSansFontWeights.light}
								sx={sidebarContentSX.title}
							>
								{title}
							</Typography>
						)}
					</Stack>
					<Divider sx={sidebarContentSX.divider} />
				</>
			)}
			{children}
		</Paper>
	);
};
